<div *ngIf="isOpen"
  class="fixed inset-0 z-[70] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4 animate-fade-in">
  <div
    class="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-sm relative overflow-hidden animate-scale-up flex flex-col max-h-[90vh] border border-slate-100/50">

    <!-- Close button -->
    <button (click)="onClose()"
      class="absolute top-4 right-4 w-8 h-8 p-2 rounded-full bg-white/80 hover:bg-slate-100 text-slate-400 hover:text-rose-500 transition-colors flex items-center justify-center shadow-sm z-10 border border-slate-100">
      <img src="icons/arrow_back_white.svg" class="w-full h-full" />
    </button>

    <!-- Header Section -->
    <div class="bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] pt-10 pb-6 px-6 text-center relative shadow-sm text-white">
      <h3 class="text-lg font-black tracking-wide text-white">
        {{ currentLang === 'TH' ? 'เลือกทะเบียนรถยนต์' : 'Select License Plate' }}
      </h3>
      <p class="text-[10px] text-amber-400 font-bold mt-1 uppercase tracking-wider">
        {{ currentLang === 'TH' ? 'กรุณาเลือก 1 ทะเบียนเพื่อขอผูกกับบัตร' : 'Please select 1 plate to link' }}
      </p>
    </div>

    <!-- Scrollable container -->
    <div class="p-6 overflow-y-auto flex-1 relative min-h-[150px] custom-scrollbar">

      <div *ngIf="isLoading" class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 z-10">
        <app-pss-loading></app-pss-loading>
      </div>

      <div *ngIf="!isLoading && selectedVehicles.length === 0"
        class="flex flex-col items-center justify-center py-10 text-slate-400">
        <i class="fa fa-car text-4xl opacity-40 mb-2"></i>
        <p class="text-xs font-bold">{{ currentLang === 'TH' ? 'ไม่พบข้อมูลทะเบียนรถของคุณ' : 'No license plate found'
          }}</p>
      </div>

      <div *ngIf="!isLoading && selectedVehicles.length > 0" class="space-y-2.5">
        <div *ngFor="let v of selectedVehicles" (click)="onSelectVehicle(v)"
          class="p-3.5 border rounded-2xl cursor-pointer transition-all flex items-center justify-between" [ngClass]="{
            'border-amber-400 bg-amber-400/5 shadow-sm': selectedVehicle?.vehicle_id === v.vehicle_id,
            'border-slate-100 bg-slate-50 hover:bg-slate-100/70': selectedVehicle?.vehicle_id !== v.vehicle_id
          }">
          <!-- Plate details -->
          <div
            class="flex items-center border border-slate-300 shadow-sm bg-white rounded-md px-3 py-1 min-w-[90px] justify-center relative overflow-hidden text-left">
            <span class="text-xs font-black text-slate-800 tracking-wide font-prompt text-center leading-none">
              {{ v.plate_number }}
              <span class="text-[7px] text-slate-400 font-bold block leading-none text-center mt-1">
                {{ v.province_name }}
              </span>
            </span>
          </div>

          <!-- Radio Select indicator -->
          <div class="w-5 h-5 rounded-full border-2 flex flex-shrink-0 items-center justify-center transition-colors"
            [ngClass]="{
                 'border-amber-400 bg-amber-400 text-slate-800': selectedVehicle?.vehicle_id === v.vehicle_id,
                 'border-slate-300 bg-white': selectedVehicle?.vehicle_id !== v.vehicle_id
               }">
            <img *ngIf="selectedVehicle?.vehicle_id === v.vehicle_id" src="icons/check_slate_dark.svg" />
          </div>
        </div>
      </div>
    </div>

    <!-- Confirm Button -->
    <div class="p-6 pt-2 bg-white border-t border-slate-100">
      <button [disabled]="!selectedVehicle"
        class="w-full py-3.5 rounded-2xl text-xs font-black shadow-md transition-all flex justify-center items-center gap-1.5 outline-none border-none"
        [ngClass]="{
          'bg-slate-200 text-slate-400 cursor-not-allowed shadow-none': !selectedVehicle,
          'bg-amber-400 text-slate-800 hover:bg-amber-500 active:scale-95': selectedVehicle
        }" (click)="onConfirm()">
        <img *ngIf="!selectedVehicle" src="icons/check_circle_slate.svg" />
        <img *ngIf="selectedVehicle" src="icons/check_circle_slate_dark.svg" />
        {{ currentLang === 'TH' ? 'ยืนยันการขอแก้ไขทะเบียน' : 'Confirm Change Plate' }}
      </button>
    </div>

  </div>
</div>